/**
 * Transform assignments array to unique expedients array
 * @param {Array} assignments - Array of assignments
 * @returns {Array} Array of unique expedients
 */
export const transformAssignmentsToExpedients = assignments => {
  const expedientsMap = new Map();

  assignments.forEach(assignment => {
    if (assignment.expedient_id) {
      const expedientId = assignment.expedient_id.expedient_id || assignment.expedient_id._id;
      const expedientIdStr = expedientId?.toString() || expedientId;
      if (expedientIdStr && !expedientsMap.has(expedientIdStr)) {
        expedientsMap.set(expedientIdStr, assignment.expedient_id);
      }
    }
  });

  return Array.from(expedientsMap.values());
};

/**
 * Get expedient ID as string
 * @param {Object} expedient - Expedient object
 * @returns {string} Expedient ID as string
 */
export const getExpedientId = expedient => {
  if (!expedient) return null;
  const expedientId = expedient.expedient_id || expedient._id;
  return expedientId?.toString() || expedientId;
};

/**
 * Check if two expedients are the same
 * @param {Object} expedient1 - First expedient
 * @param {Object} expedient2 - Second expedient
 * @returns {boolean} True if expedients are the same
 */
export const isSameExpedient = (expedient1, expedient2) => {
  if (!expedient1 || !expedient2) return false;
  const id1 = getExpedientId(expedient1);
  const id2 = getExpedientId(expedient2);
  return id1 === id2;
};

/**
 * Check if expedient exists in list
 * @param {Array} expedientsList - List of expedients
 * @param {string} expedientId - Expedient ID to check
 * @returns {boolean} True if expedient exists in list
 */
export const expedientExistsInList = (expedientsList, expedientId) => {
  if (!Array.isArray(expedientsList)) {
    return false;
  }
  const expedientIdStr = expedientId?.toString();
  return expedientsList.some(exp => {
    const expId = getExpedientId(exp);
    return expId?.toString() === expedientIdStr;
  });
};

